import FormLabel from "./FormLabel" ;
const TextArea = (props) => {
    const { label, value, onChange, className, mandatory = true, name } =props
    const onChangeHandler = (e) => {
        if (onChange) {
            onChange (e)
        }
    }
    return (
        <>
        {label && 
            <FormLabel label = {label} mandatory = {mandatory}/>
        }   
        <div className = "input-group">
            <textarea className={"form-control f-s13 "+className} value = {value} name = {name} onChange = { (e) => onChangeHandler (e)}/>
        </div>
        </>
    )
}
export default TextArea